var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader'),_c('br'),_c('div',{staticClass:"container-fluid"},[_c('v-overlay',{attrs:{"value":_vm.loading}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1),_c('AppTable',{ref:"tableComponent",attrs:{"cargadores":_vm.Listacargadores}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }